import { createSlice } from "@reduxjs/toolkit";
import {
  addClassesToSchool,
  getAllClasses,
  getClassesForSchool,
} from "../services/class_service";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "class",

  initialState: {
    isLoadingAllClasses: false,
    isLoadingClassesForSchool: false,
    isLoadingAddClassesToSchool: false,
    isLoadingAddSectionToClass: false,
    allClasses: [],
    classInfo: {},
  },

  reducers: {
    setClassInfo: (state, action) => {
      state.classInfo = action.payload;
    },
  },

  extraReducers: {
    // ==> get Classes For School
    [getClassesForSchool.fulfilled]: (state, action) => {
      state.isLoadingClassesForSchool = false;
      state.schoolClasses = action.payload.data;
    },
    [getClassesForSchool.rejected]: (state, action) => {
      state.isLoadingClassesForSchool = false;
    },
    [getClassesForSchool.pending]: (state) => {
      state.isLoadingClassesForSchool = true;
    },

    // ==> get All Classes
    [getAllClasses.fulfilled]: (state, action) => {
      state.isLoadingAllClasses = false;
      state.allClasses = action.payload.data;
    },
    [getAllClasses.rejected]: (state, action) => {
      state.isLoadingAllClasses = false;
    },
    [getAllClasses.pending]: (state) => {
      state.isLoadingAllClasses = true;
    },

    // ==> add Classes ToSchool
    [addClassesToSchool.fulfilled]: (state, action) => {
      state.isLoadingAddClassesToSchool = false;
    },
    [addClassesToSchool.rejected]: (state, action) => {
      state.isLoadingAddClassesToSchool = false;
    },
    [addClassesToSchool.pending]: (state) => {
      state.isLoadingAddClassesToSchool = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setClassInfo } = slice.actions;
